import axios from "axios";
import * as actions from "./actionsType";
import messages from "../../messages";
import toastr from "toastr";
import PlansServices from "./Plans.services";

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const getPlan = (filters) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLAN,
      payload: true,
    });
    debugger
    const resp = await PlansServices.getPlan(filters);
    dispatch({
      type: actions.GET_PLAN,
      payload: {
        plans: resp.data.data,
        plansLength: resp.data.count,
      },
    });
    dispatch({
      type: actions.PLAN_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PLAN_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN,
      payload: false,
    });
  }
};

export const cleanFail = () => async (dispatch) => {
  dispatch({
    type: actions.FORM_PLAN_FAIL,
    payload: "",
  });
};

export const getPlanById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_PLAN_BY_ID,
      payload: true,
    });
    const resp = await PlansServices.getPlanByID(id);
    dispatch({
      type: actions.GET_PLAN_BY_ID,
      payload: resp.data,

    });
    dispatch({
      type: actions.PLAN_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.PLAN_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN_BY_ID,
      payload: false,
    });
  }
};

export const savePlan =
  (data, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.SAVE_LOADING_PLAN,
        payload: true,
      });
      const resp = await PlansServices.savePlan(data);
      const { plans, plansLength } = getState().planCarreraPlan;
      const _planes = [...plans, resp.data.data];
      dispatch({
        type: actions.GET_PLAN,
        payload: {
          plans: _planes,
          plansLength: plansLength + 1,
        },
      });
      dispatch({
        type: actions.FORM_PLAN_FAIL,
        payload: "",
      });
      setShowModal(false);
      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_PLAN_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.SAVE_LOADING_PLAN,
        payload: false,
      });
    }
  };

export const editPlan =
  (idPlan, idPlanAccion, dataPlan, dataPlanAccion, index, setShowModal) => async (dispatch, getState) => {
    try {
      dispatch({
        type: actions.LOADING_PLAN,
        payload: true,
      });
      await PlansServices.editPlanAccion(idPlanAccion, dataPlanAccion)
      const resp = await PlansServices.editPlan(idPlan, dataPlan);
      const { plans, plansLength } = getState().planCarreraPlan;
      let _planes = [...plans]
      _planes[index] = resp.data;
      dispatch({
        type: actions.GET_PLAN,
        payload: {
          plans: _planes,
          plansLength: plansLength,
        },
      });
      dispatch({
        type: actions.FORM_PLAN_FAIL,
        payload: "",
      });
      setShowModal(false);

      toastr.success(messages.successMessage, " ", {
        progressBar: true,
        rtl: true,
      });
    } catch (ex) {
      let message = null;
      if (axios.isAxiosError(ex)) {
        if (ex.response?.status) {
          switch (ex.response.status) {
            case 400:
              const apiMessage = ex.response?.data?.mensaje;  // Accede al mensaje en la respuesta (para el caso en el que el plan ya tiene cursos asignados)
              message = messages.errorMessage;

              if (apiMessage) {
                message += ". " + apiMessage;  // Agrega el mensaje de la API al mensaje de error
              }
              break;
            case 403:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 404:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            case 500:
              message = messages.errorMessage + " " + ex.response.statusText;
              break;
            default:
              message = ex.response.data;
              break;
          }
        } else {
          message =
            ex.message === "Network Error" ? messages.networkError : ex.message;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
      dispatch({
        type: actions.FORM_PLAN_FAIL,
        payload: message,
      });
    } finally {
      dispatch({
        type: actions.LOADING_PLAN,
        payload: false,
      });
    }
  };

export const deletePlan = (id, index) => async (dispatch, getState) => {
  try {

    dispatch({
      type: actions.LOADING_PLAN,
      payload: true,
    });
    await PlansServices.deletePlan(id);
    const { plans, plansLength } = getState().planCarreraPlan;
    let _planes = [...plans]
    _planes.splice(index, 1);
    dispatch({
      type: actions.GET_PLAN,
      payload: {
        plans: _planes,
        plansLength: plansLength - 1,
      },
    });
    dispatch({
      type: actions.PLAN_FAIL,
      payload: "",
    });

    toastr.success(messages.successMessage, " ", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 403:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }

    dispatch({
      type: actions.PLAN_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_PLAN,
      payload: false,
    });
  }
};
